/**
 * Is the node process client side (browser)
 */
export const isProcessClient = () => process.client
/**
 * Is the node process server side (node)
 */
export const isProcessServer = () => process.server
